(ns ycweb.app.website.school.common
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(defn school-bundle-banner
  [{:keys [bundle-name price price-was url]}]
  [:div
   {:class (u/bem :yc-section [:standard])}
   [:article.ocs-bundle-card
    [:a.block-link.group
     {:href url}
     [:div.ocs-bundle-card__hero
      [:img.ocs-bundle-card__image
       {:src
        "https://res.cloudinary.com/yuppiechef/image/upload/v1474370008/pages/cooking-school/ocs-bundle-hero.png"
        :alt "Cooking School Course Bundle"}]]
     [:div.ocs-bundle-card__content
      (when (= price 0)
        [:div.u-text-12.u-margin-bottom-10.u-text-uppercase.u-text-red
         "Limited Time Offer"])
      [:h1.ocs-bundle-card__heading bundle-name]
      [:p.yc-paragraph.ocs-bundle-card__description
       "Get unrestricted access to all Online Cooking School courses - video tutorials, course notes, guides and quizzes - "
       [:b "worth over R3,000!"]]
      [:ul.ocs-bundle-card__price-list.group
       (cond
         (> price-was 0)
         (list
           [:li
            {:class (u/bem :ocs-bundle-card__price [:now])}
            "Now " "R" price]
           [:li
            {:class (u/bem :ocs-bundle-card__price [:was])}
            "Was " "R" price-was])

         :else
         (if (> price 0)
           [:li.ocs-bundle-card__price
            "R" price]
           [:li.u-text-uppercase
            {:class (u/bem :ocs-bundle-card__price [:now])}
            "Free"]))]]

     [:div.ocs-bundle-card__badge-wrapper
      [:img.ocs-bundle-card__badge
       {:src
        "https://res.cloudinary.com/yuppiechef/image/upload/v1474370007/pages/cooking-school/ocs-bundle-full-access-badge.png"
        :alt "Best Value"}]]]]])

(rum/defc school-card < rum/reactive
  [app-atom
   {:ent/keys [display-name image]
    :course/keys [short-course coming-soon? min-price min-price-was progress host owned? courseLink]
    :item-line/keys [product] :as course}]
  [:div
   {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-3])}
   [:article.card.product-card.course-card.flex-grid-content
    [:a.u-block-link
     (if
       owned?
       (urlstate/href-props app-atom "cooking-school" "mycourseview" {:uuid (:ent/uuid course)})
       {:href (:product/link product)})
     [:div.card__hero

      (web-common/lazy-image app-atom
        (:doc/public-id image)
        {:class ["card__image"]}
        {:w 318
         :h 198
         :q "auto"
         :alt display-name})
      (when (= short-course 1)
        [:div.card__new-sticker-wrapper
         [:div {:class (u/bem :card-sticker [:new])} "Short Course"]])
      (when (and (u/presence (:ent/display-name host)) (u/presence (:doc/public-id (:ent/image host))))
        [:div.course-card__avatar-wrapper
         (web-common/lazy-image app-atom
           (:doc/public-id (:ent/image host))
           {:class ["course-card__avatar  avatar  yc-simple-image  yc-simple-image--full  yc-simple-image--border"]}
           {:w 50
            :h 50
            :q "auto"
            :alt (:ent/display-name host)})])]
     [:div.card__content-wrapper
      [:div.card__content
       [:header.card__header
        [:h1.course-card__title
         display-name]
        (when (u/presence (:ent/display-name host))
          [:p.course-card__presenter
           [:span.clip-text.unclip-text--ml
            "Presented "]
           (str "by " (:ent/display-name host))])]

       (cond
         owned?
         [:div.product-card__cta.course-card__cta
          (buttons/button-web
            (cond
              (= progress 100)
              "Course complete"

              (and progress (> progress 0))
              (str progress "% complete")

              :else
              "Start course")
            {:type :span-button
             :style (cond (= progress 100) :cta :else :secondary)
             :size :small
             :class "product-card__button"})]
         :else
         [:div.card__description
          (cond
            (= coming-soon? 1)
            [:ul.card-price-list.group
             [:li.card-price-list__item "Coming Soon"]]

            (> min-price 0)
            [:ul.card-price-list.group
             [:li
              {:class (u/bem :card-price-list__item [(when (> min-price-was 0) :now)])}
              (when (> min-price-was 0)
                [:span.u-hidden-from-view "Now "])
              (str "R" min-price)]
             (when (> min-price-was 0)
               [:li
                {:class (u/bem :card-price-list__item [:was])}
                (str "Was R" min-price-was)])])

          [:div.card__price-sticker-wrapper
           (cond
             (and (> min-price 0) (> min-price-was 0))
             [:div
              {:class (u/bem :card-sticker [:price])}
              "Save"]
             (or (= min-price 0) (not (u/presence min-price)))
             [:div
              {:class (u/bem :card-sticker [:price])}
              "Free Course"])]])]]]]])

(rum/defc lesson-card < rum/reactive
  [app-atom idx {:module/keys [user-module-uuid title outline progress] :as module}]
  [:article.card.lesson-card
   [:a.block-link
    (urlstate/href-props app-atom "cooking-school" "moduleview" {:uuid user-module-uuid})
    [:div.lesson-card__content-wrapper
     [:div.lesson-card__hero
      [:div.lesson-card__image-crop
       (web-common/lazy-image app-atom
         (:doc/public-id (:ent/image module))
         {:class ["lesson-card__image"]}
         {:w 480
          :h 288
          :c "fit"
          :q "auto"
          :alt title})]]
     [:div.lesson-card__content
      [:small.lesson-card__context (str "Lesson " (+ idx 1))]
      [:h3.lesson-card__title title]
      [:div.lesson-card__description
       {:dangerouslySetInnerHTML {:__html outline}}]
      [:footer.lesson-card__cta.group
       [:div.lesson-card__button-wrapper
        (buttons/button-web
          (cond
            (= progress 100)
            "View lesson"
            (= progress 0)
            "Begin lesson"
            :else
            "Continue lesson")
          {:type :span-button
           :style :secondary
           :size :small})]
       (when (and progress (pos? progress))
         [:div.lesson-card__status-wrapper
          [:span (str progress "% Complete")]])]]]
    (when (and progress (pos? progress))
      [:div.card__progress-wrapper
       [:div.card__progress {:style {:width (str progress "%")}}]])]])

(rum/defc lesson-item-card < rum/reactive
  [app-atom {:ent/keys [image display-name]
             :item/keys [outline button-text] :as module}]
  [:article.card.lesson-card
   [:a.block-link
    (merge
      (urlstate/href-props app-atom "cooking-school" "moduledetail" {:uuid (:ent/uuid module) :overrideincludes "moduledetail"})
      {:target "_blank"})
    [:div.lesson-card__content-wrapper
     [:div.lesson-card__hero
      [:div.lesson-card__image-crop
       (web-common/lazy-image app-atom
         (:doc/public-id image)
         {:class ["lesson-card__image"]}
         {:w 480
          :h 288
          :c "fit"
          :q "auto"
          :alt display-name})]]
     [:div.lesson-card__content
      [:small.lesson-card__context "Lesson notes"]
      [:h3.lesson-card__title display-name]
      [:div.lesson-card__description
       {:dangerouslySetInnerHTML {:__html outline}}]
      [:footer.lesson-card__cta.group
       [:div.lesson-card__button-wrapper
        (buttons/button-web
          (if (u/presence button-text) button-text "View notes")
          {:type :span-button
           :style :secondary
           :size :small})]]]]]])
